import {Box, FormContext} from "@hosttools/frontend/components";
import type React from "react";
import {useContext, useEffect, useRef} from "react";

import {TableContext} from "./TabContext";

export type Props = {
    id: string;
    // temporarily keep this title here and read this inside the parent `Tabs` component
    // until we have a better design on Tab component
    /* eslint-disable react/no-unused-prop-types */
    title: string;
    children: React.ReactNode;
};

const Tab: React.FC<Props> = ({id, children}) => {
    const formContext = useContext(FormContext);
    const {withForm} = useContext(TableContext);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (formContext && contentRef.current && withForm) {
            const anchorNodes = contentRef.current.querySelectorAll(
                "[data-field-type='anchor-field']"
            );
            anchorNodes.forEach(anchorNode => {
                const fieldName = anchorNode.getAttribute("data-field-name");
                if (fieldName) {
                    formContext.setFieldGroup(fieldName, id);
                }
            });
        }
    }, [formContext, id, withForm]);

    return (
        <Box ref={contentRef} className="w-full px-px" testID="tab-wrapper">
            {children}
        </Box>
    );
};

export default Tab;
